import RecipeIngredientTable from "@/components/RecipeComponents/RecipeSingleView/RecipeIngredientList/RecipeIngredientTable/RecipeIngredientTable";
import { RecipeType, StepZutat } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { MutableRefObject } from "react";
import Image from "next/image";
import styles from "./StepsContent.module.scss";
interface StepsContentProps {
  recipeDetails: RecipeType;
  ingredients: StepZutat[];
  stepIndex: number;
  stepText: MutableRefObject<HTMLDivElement | null>;
}

export const StepsContent = ({
  recipeDetails,
  // ingredients,
  stepIndex,
  stepText,
}: StepsContentProps) => {
  const { getLabel } = useGlobalContext();
  const recipeDifficulty = recipeDetails.schwierigkeitsgrad;

  const step = recipeDetails.steps_portion_big?.[stepIndex];
  if (!step) return null;

  const hasIllustration = Boolean(step.step_illustration);
  const a11yTitle =
    step.step_titel && step.step_titel.trim().length > 0
      ? step.step_titel
      : String(stepIndex + 1);
  const altText = getLabel("aria_label_illustration_image").replace(
    "$$title",
    a11yTitle,
  );
  const mediaColsByDiff: Record<number, string> = {
    1: "is-12-tablet is-7-desktop",
    2: "is-12-tablet is-7-desktop",
    3: "is-12",
  };

  const textColsByDiff: Record<number, string> = {
    1: "is-8-tablet is-5-desktop",
    2: "is-8-tablet is-5-desktop",
    3: "is-8-tablet",
  };

  const mediaCols = mediaColsByDiff[recipeDifficulty] ?? "is-12";
  const textCols = textColsByDiff[recipeDifficulty] ?? "is-12";
  return (
    <div className="columns is-centered is-multiline">
      {hasIllustration ? (
        <div className={`column  ${mediaCols}`}>
          <figure className={`image-wrapper ${styles["step-illustration"]}`}>
            <Image
              src={step.step_illustration}
              height={step.step_illustration_height}
              width={step.step_illustration_width}
              sizes="(max-width: 1023px) 95vw, 45vw"
              alt={altText}
            />

            {/* {recipeDifficulty === 1 && (
              <InlineMediaInfo
                description={step.step_beschreibung}
                focusOnOpen
              />
            )} */}
          </figure>
        </div>
      ) : null}

      <div className={`column ${textCols} ${styles["step-text-container"]}`}>
        <RecipeIngredientTable ingredients={step.step_zutaten} />
        {step.step_beschreibung && (
          <>
            <div className={"is-block mt-3 mb-3 " + styles.line} />
            <div
              className={styles["step-text"]}
              ref={stepText}
              dangerouslySetInnerHTML={{
                __html: step.step_beschreibung,
              }}
            />
          </>
        )}
      </div>
      {/* {recipeDifficulty > 1 && (
      )} */}
    </div>
  );
};

export default StepsContent;
